import PackagesTable from "./pages/PackagesTable";


const Packages: React.FC = () => {
  return (
    <div className="">
     <PackagesTable/>
    </div>
  );
};

export default Packages;
